import { render, staticRenderFns } from "./CreateReferenceModel.vue?vue&type=template&id=cabb5fe6&"
import script from "./CreateReferenceModel.vue?vue&type=script&lang=js&"
export * from "./CreateReferenceModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports